import AIRequester from '@cobliteam/api-lib/src/dashboard/ai/AIRequester';
import Environment from '@cobliteam/react-environments';
import { useQuery } from '@tanstack/react-query';

export const AUTOMATIONS_QUERY_KEY = ['automations'];

export const useGetAutomations = () => {
  return useQuery({
    queryKey: AUTOMATIONS_QUERY_KEY,
    queryFn: async () => {
      const environment = Environment.getInstance().getEnvironment();
      const aiRequester = new AIRequester({ host: environment.mastraApi });
      return aiRequester.getAutomations();
    },
  });
};
